<template>
  <div class="absolute inset-x-0 top-0 z-50 w-full h-full bg-white flex flex-col items-center">
    <Logo />
    <BaseIcon icon="spinner2" class="icon-spin text-primary text-5xl mt-2" />
  </div>
</template>

<script>
import Logo from '@/components/shared/Logo.vue'
import {BaseIcon} from '@/components/base'

export default {
  components: {
    Logo,
    BaseIcon,
  },
}
</script>
